import * as Yup from 'yup';

export const updateAccountFinancialDetailsFormSchema: Yup.ObjectSchema<{}> = Yup.object().shape({
  financeId: Yup.string().nullable().required('Please enter a valid finance identifier.')
});
